import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom'
import './adminSideBar.css';
import { AuthContext } from '../../context/authContext/AuthContext';
import { logout } from '../../context/authContext/AuthActions';
import { CartContext } from '../../context/cartContext/CartContext';

function AdminSideBar({ activeTab }) {
    const [collapsed, setCollapsed] = useState(true);
    const [open, setOpen] = useState("");
    const [ulHeight, setUlHeight] = useState(0);
    const listDropDownNames = ['services1', 'bookmarks1', 'services2', 'bookmarks2']
    const { dispatch, user } = useContext(AuthContext);
    const { cart } = useContext(CartContext);

    const collapsedHandler = (e) => {
        e.preventDefault();
        setCollapsed(prev => !prev);
        setOpen('');
        setUlHeight(0);
    }
    const openHandler = (e, item) => {
        if (open === item) {
            setOpen('');
            setUlHeight(0);
        } else {
            setOpen(item);
            setUlHeight(e.target.nextElementSibling.scrollHeight);
        }
    }

    return (
        <>
            {/* <!-- Mobile Sidebar Menu Button --> */}
            <button className="sidebar-menu-button" onClick={collapsedHandler}>
                <span className="material-symbols-rounded">menu</span>
            </button>

            <aside className={collapsed ? "sidebar collapsed" : "sidebar"}>
                {/* <!-- Sidebar header--> */}
                <header className="sidebar-header">
                    <a href="#" className="header-logo">
                        <img src="/logo.png" alt="CodingNepal" />
                    </a>
                    <button className="sidebar-toggler" onClick={collapsedHandler}>
                        <span className="material-symbols-rounded">chevron_left</span>
                    </button>
                </header>

                {/* <!-- Sidebar body --> */}
                <nav className="sidebar-nav">
                    {/* <!-- Primary Top Nav --> */}
                    <ul className="nav-list primary-nav">
                        <li className={activeTab === "home" ? "nav-item active" : "nav-item"}  >
                            <Link to={`/`} className="nav-link">
                                <span className="material-symbols-rounded">dashboard</span>
                                <span className="nav-label">Dashboard</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Dashboard</a></li>
                            </ul>
                        </li>
                        <li className={activeTab === "envoie" ? "nav-item active" : "nav-item"} >
                            <Link to={`/envois`} className="nav-link">
                                <span className="material-symbols-rounded">package_2</span>
                                <span className="nav-label">Envois</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Envois</a></li>
                            </ul>
                        </li>
                        {/* <li className={activeTab === "cart" ? "nav-item active" : "nav-item"} >
                            <Link to={`/cart`} className="nav-link">
                                <span className="material-symbols-rounded">shopping_cart</span>
                                {cart.length === 0 ? '' : <small>{cart.length}</small>}
                                <span className="nav-label">Panier</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Panier</a></li>
                            </ul>
                        </li> */}
                        <li className={activeTab === "action" ? "nav-item active" : "nav-item"} >
                            <Link to={`/actions`} className="nav-link">
                                <span className="material-symbols-rounded">webhook</span>
                                {cart.length === 0 ? '' : <small>{cart.length}</small>}
                                <span className="nav-label">Actions</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Actions</a></li>
                            </ul>
                        </li>
                        <li className={activeTab === "invoice" ? "nav-item active" : "nav-item"} >
                            <Link to={`/invoices`} className="nav-link">
                                <span className="material-symbols-rounded">point_of_sale</span>
                                <span className="nav-label">Factures</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Factures</a></li>
                            </ul>
                        </li>
                        <li className={activeTab === "movement" ? "nav-item active" : "nav-item"} >
                            <Link to={`/movements`} className="nav-link">
                                <span className="material-symbols-rounded">sync_arrow_up</span>
                                <span className="nav-label">Movements</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Movements</a></li>
                            </ul>
                        </li>
                        {
                            (user.role === 1 || user.role === 2) && (
                                <li className={activeTab === "cost" ? "nav-item active" : "nav-item"} >
                                    <Link to={`/costs`} className="nav-link">
                                        <span className="material-symbols-rounded">payments</span>
                                        <span className="nav-label">Prix</span>
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li className="nav-item"><a className="nav-link dropdown-title">Prix</a></li>
                                    </ul>
                                </li>
                            )
                        }
                        {/* <li className={activeTab === "notification" ? "nav-item active" : "nav-item"} >
                            <Link to={`/notifications`} className="nav-link">
                                <span className="material-symbols-rounded">notifications</span>
                                <span className="nav-label">Notifications</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Notifications</a></li>
                            </ul>
                        </li> */}
                        {
                            (user.role === 1 || user.role === 2) && (
                                <li className={activeTab === "agence" ? "nav-item active" : "nav-item"} >
                                    <Link to={`/agences`} className="nav-link">
                                        <span className="material-symbols-rounded">local_convenience_store</span>
                                        <span className="nav-label">Agences</span>
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li className="nav-item"><a className="nav-link dropdown-title">Agences</a></li>
                                    </ul>
                                </li>
                            )
                        }
                        {
                            (user.role === 1 || user.role === 2) && (
                                <li className={activeTab === "entreprise" ? "nav-item active" : "nav-item"} >
                                    <Link to={`/entreprises`} className="nav-link">
                                        <span className="material-symbols-rounded">Apartment</span>
                                        <span className="nav-label">Entreprises</span>
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li className="nav-item"><a className="nav-link dropdown-title">Entreprises</a></li>
                                    </ul>
                                </li>
                            )
                        }
                        <li className={activeTab === "agent" ? "nav-item active" : "nav-item"}>
                            <Link to={`/agents`} className="nav-link">
                                <span className="material-symbols-rounded">support_agent</span>
                                <span className="nav-label">Agents</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Agents</a></li>
                            </ul>
                        </li>
                        <li className={activeTab === "delivery" ? "nav-item active" : "nav-item"}>
                            <Link to={`/deliveries`} className="nav-link">
                                <span className="material-symbols-rounded">engineering</span>
                                <span className="nav-label">Livs | Trs</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Livs | Trs</a></li>
                            </ul>
                        </li>
                        <li className={activeTab === "client" ? "nav-item active" : "nav-item"} >
                            <Link to={`/clients`} className="nav-link">
                                <span className="material-symbols-rounded">partner_exchange</span>
                                <span className="nav-label">Clients | business</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Clients | business</a></li>
                            </ul>
                        </li>
                        {
                            (user.role === 1 || user.role === 2) && (
                                <li className={activeTab === "setting" ? "nav-item active" : "nav-item"} >
                                    <Link to={`/settings`} className="nav-link">
                                        <span className="material-symbols-rounded">settings</span>
                                        <span className="nav-label">Paramètres</span>
                                    </Link>
                                    <ul className="dropdown-menu">
                                        <li className="nav-item"><a className="nav-link dropdown-title">Paramètres</a></li>
                                    </ul>
                                </li>
                            )
                        }


                        {/* <li className={open === listDropDownNames[2] ? "nav-item dropdown-container open" : "nav-item dropdown-container"}>
                            <a href="#" className="nav-link dropdown-toggle" onClick={(e)=>openHandler(e,listDropDownNames[2])}>
                                <span className="material-symbols-rounded">calendar_today</span>
                                <span className="nav-label">Services</span>
                                <span className="material-symbols-rounded dropdown-icon">keyboard_arrow_down</span>
                            </a>
                            <ul className="dropdown-menu services2"  style={open === listDropDownNames[2] ? {height: ulHeight} : {height: 0}}>
                                <li className="nav-item"><a className="nav-link dropdown-title">Services</a></li>
                                <li className="nav-item"><a href="#" className="nav-link dropdown-link">IT Consulting</a></li>
                                <li className="nav-item"><a href="#" className="nav-link dropdown-link">Cloud Solutions</a></li>
                                <li className="nav-item"><a href="#" className="nav-link dropdown-link">Mobile Apps</a></li>
                                <li className="nav-item"><a href="#" className="nav-link dropdown-link">Cloud Solutions</a></li>
                                <li className="nav-item"><a href="#" className="nav-link dropdown-link">Mobile Apps</a></li>
                            </ul>
                        </li>
                        <li className={open === listDropDownNames[3] ? "nav-item dropdown-container open" : "nav-item dropdown-container"}>
                            <a href="#" className="nav-link dropdown-toggle" onClick={(e)=>openHandler(e,listDropDownNames[3])}>
                                <span className="material-symbols-rounded">star</span>
                                <span className="nav-label">Bookmarks</span>
                                <span className="material-symbols-rounded dropdown-icon">keyboard_arrow_down</span>
                            </a>
                            <ul className="dropdown-menu bookmarks2"  style={open === listDropDownNames[3] ? {height: ulHeight} : {height: 0}}>
                                <li className="nav-item"><a className="nav-link dropdown-title">Bookmarks</a></li>
                                <li className="nav-item"><a href="#" className="nav-link dropdown-link">Saved Tutorials</a></li>
                                <li className="nav-item"><a href="#" className="nav-link dropdown-link">Favourite Blogs</a></li>
                                <li className="nav-item"><a href="#" className="nav-link dropdown-link">Resources Guides</a></li>
                                <li className="nav-item"><a href="#" className="nav-link dropdown-link">Saved Tutorials</a></li>
                                <li className="nav-item"><a href="#" className="nav-link dropdown-link">Favourite Blogs</a></li>
                                <li className="nav-item"><a href="#" className="nav-link dropdown-link">Resources Guides</a></li>
                                <li className="nav-item"><a href="#" className="nav-link dropdown-link">Saved Tutorials</a></li>
                                <li className="nav-item"><a href="#" className="nav-link dropdown-link">Favourite Blogs</a></li>
                                <li className="nav-item"><a href="#" className="nav-link dropdown-link">Resources Guides</a></li>
                            </ul>
                        </li> */}
                    </ul>

                    {/* <!-- Secondary Bottom Nav --> */}
                    <ul className="nav-list secondary-nav">
                        <li className={activeTab === "infoperson" ? "nav-item active" : "nav-item"} >
                            <Link to={`/infoperson`} className="nav-link">
                                <span className="material-symbols-rounded">help</span>
                                <span className="nav-label">Infos Personnelles</span>
                            </Link>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Infos Personnelles</a></li>
                            </ul>
                        </li>
                        <li className="nav-item" onClick={() => dispatch(logout())}>
                            <a href="#" className="nav-link">
                                <span className="material-symbols-rounded">logout</span>
                                <span className="nav-label">Sign Out</span>
                            </a>
                            <ul className="dropdown-menu">
                                <li className="nav-item"><a className="nav-link dropdown-title">Sign Out</a></li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            </aside>
        </>
    )
}

export default AdminSideBar
